const alpha = (value: string): string => value && value.replace(/[^A-Za-z ]/g, '');

export default alpha;
